import { Button, PresetThemes } from '@travelnest/merlin.button';
import * as React from 'react';
import { SaveState } from '../../../types';

export type SaveButtonAlignment = 'left' | 'right';

// TODO: Fix up removing all the unused props

export interface ISaveButtonProps {
	saving: boolean;
	buttonLabel?: string;
	successMessage?: string;
	errorMessage?: string;
	disabled?: boolean;
	saveState?: SaveState;
	alignment?: SaveButtonAlignment;
	onClick: (e: any) => any;
	id?: string;
	badge?: string;
}

export const SaveButton: React.FC<ISaveButtonProps> = (props) => {
	const { saving, disabled, saveState, alignment, id, badge, onClick, buttonLabel, successMessage, errorMessage } = props;
	const classNames = `save-button ${alignment === 'left' ? 'save-button_align-left' : 'save-button_align-right'}`;

	return <React.Fragment>
		<div className={classNames}>
			<div className="save-button__container">
				{badge &&
					<div className="save-button__badge">{badge}</div>
				}
				<Button
					buttonType={PresetThemes.Primary}
					id={id}
					loading={saving}
					disabled={disabled}
					onClick={(e) => onClick(e)}
				>
					{buttonLabel || 'Save changes'}
				</Button>
			</div>
			<div className="save-button__label">
				{saveState === SaveState.SUCCESS &&
					<label className="save-button__label-help">{successMessage}</label>
				}
				{saveState === SaveState.FAILURE &&
					<label className="save-button__label-error">{errorMessage}</label>
				}
			</div>
		</div>
	</React.Fragment>;
};
